import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { EnquiryProvider } from "@/context/EnquiryContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import MobileStickyCTA from "@/components/MobileStickyCTA";

import Home from "@/pages/Home";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBuyerDetail from "@/pages/admin/AdminBuyerDetail";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import EnquiryCart from "@/pages/EnquiryCart";
import QuoteRequest from "@/pages/QuoteRequest";
import Quality from "@/pages/Quality";
import Certifications from "@/pages/Certifications";
import Packaging from "@/pages/Packaging";
import Logistics from "@/pages/Logistics";
import GlobalSupply from "@/pages/GlobalSupply";
import Contact from "@/pages/Contact";
import EnquiryConfirmation from "@/pages/EnquiryConfirmation";

const ScrollToTop = () => {
  useEffect(() => {
    const handler = () => window.scrollTo({ top: 0, behavior: "instant" });
    handler();
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <EnquiryProvider>
          <ScrollToTop />
          <Header />
          <main className="min-h-[70vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:category" element={<Products />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/enquiry-cart" element={<EnquiryCart />} />
              <Route path="/request-quote" element={<QuoteRequest />} />
              <Route path="/quality" element={<Quality />} />
              <Route path="/certifications" element={<Certifications />} />
              <Route path="/packaging" element={<Packaging />} />
              <Route path="/logistics" element={<Logistics />} />
              <Route path="/global-supply" element={<GlobalSupply />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightArticle />} />
              <Route path="/enquiry-confirmed/:id" element={<EnquiryConfirmation />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/enquiries/:id" element={<AdminBuyerDetail />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </main>
          <Footer />
          <MobileStickyCTA />
          <FloatingWhatsApp />
          <Toaster position="top-right" richColors />
        </EnquiryProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
